
const FREE_GIFT_VARIANT_ID = "44196679942188";
const THRESHOLD_AMOUNT     = 500.00;
const DISCOUNT_CODE        = "FREE_LANDON";
const DISCOUNT_AMOUNT      = 90.00; // Informational — value of the discount code
const GIFT_INVENTORY_CUTOFF = 5;

let isUpdating = false;


function isGiftItem(item) {
  return (
    item.variant_id == FREE_GIFT_VARIANT_ID &&
    item.properties &&
    Object.prototype.hasOwnProperty.call(item.properties, "_discount_promo")
  );
}

function findGiftLine(cart) {
  return cart.items.find(item => isGiftItem(item));
}

function cartContainsPart(cart) {
  return cart.items.some(item => item.properties?.type === "part");
}

function getCartTotalExcludingGift(cart) {
  const itemsTotal = cart.items.reduce((sum, item) => {
    if (isGiftItem(item)) {
      // If someone somehow has qty > 1, count only the extra units' value
      return sum + (item.quantity > 1 ? (item.line_price - item.price) / 100 : 0);
    }
    return sum + item.line_price / 100;
  }, 0);

  const discountTotal = (cart.cart_level_discount_applications?.length > 0)
    ? cart.cart_level_discount_applications.reduce(
        (sum, d) => sum + d.total_allocated_amount / 100, 0
      )
    : 0;

  return itemsTotal + discountTotal;
}


async function addGiftToCart() {
  try {
    const variantRes = await fetch(`/variants/${FREE_GIFT_VARIANT_ID}.js`, { cache: "no-store" });
    if (!variantRes.ok) return null;

    const variantData = await variantRes.json();
    if (!variantData.available) return null;
    if (variantData.inventory_quantity <= GIFT_INVENTORY_CUTOFF) return null; 

    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Free-Gift-Internal": "true",
      },
      body: JSON.stringify({
        items: [{
          id: FREE_GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            "_discount_promo": "Free Landon Clock with Purchase Over $500",
          },
        }],
      }),
    });

    // Nudge cart attributes to trigger any server-side recalculation
    const nudgeRes = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Free-Gift-Internal": "true",
      },
      body: JSON.stringify({
        attributes: { "_gift_recalc": Date.now().toString() },
      }),
    });

    return await nudgeRes.json();
  } catch (err) {
    console.error("[FreeGift] addGiftToCart error:", err);
    return null;
  }
}

async function removeGiftFromCart() {
  try {
    const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
    const giftItem = findGiftLine(cart);
    if (!giftItem) return cart; // Nothing to remove

    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Free-Gift-Internal": "true",
      },
      body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
    });

    return await res.json();
  } catch (err) {
    console.error("[FreeGift] removeGiftFromCart error:", err);
    return null;
  }
}

async function enforceGiftQuantityLimit(cart, limit = 1) {
  const giftItem = findGiftLine(cart);
  if (giftItem && giftItem.quantity > limit) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Free-Gift-Internal": "true",
      },
      body: JSON.stringify({ id: giftItem.key, quantity: limit }),
    });
    return res.ok;
  }
  return false;
}


async function applyDiscountCode(code) {
  console.log("[FreeGift] Applying discount code:", code);
  try {
    const res = await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
      method: "GET",
      headers: { "X-Free-Gift-Internal": "true" },
    });
    console.log("[FreeGift] Discount response:", res.status, res.url);
  } catch (err) {
    console.error("[FreeGift] applyDiscountCode error:", err);
  }
}

async function removeDiscountCode() {
  console.log("[FreeGift] Removing discount code.");
  try {
    // 1. Clear the discount stored in cart attributes (works for most themes)
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Free-Gift-Internal": "true",
      },
      body: JSON.stringify({ discount: "" }),
    });

    // 2. Hit the discount-clear URL to remove the session-level discount cookie
    await fetch("/discount/clear?redirect=/cart", {
      method: "GET",
      headers: { "X-Free-Gift-Internal": "true" },
    });
  } catch (err) {
    console.error("[FreeGift] removeDiscountCode error:", err);
  }
}


async function syncFreeGift() {
  if (isUpdating) return;
  isUpdating = true;

  const checkoutBtn = document.getElementById("checkout");
  if (checkoutBtn) checkoutBtn.disabled = true;

  try {
    let cart = await fetch("/cart.js").then(r => r.json());

    // — Guard: enforce gift quantity cap first —
    const quantityCorrected = await enforceGiftQuantityLimit(cart);
    if (quantityCorrected) {
      cart = await fetch("/cart.js").then(r => r.json());
      refreshCartUI(cart);
    }

    const hasPart       = cartContainsPart(cart);
    const cartTotal     = getCartTotalExcludingGift(cart);
    const meetsThreshold = cartTotal >= THRESHOLD_AMOUNT;
    const giftLine      = findGiftLine(cart);

    const promotionEligible = !hasPart && meetsThreshold;

    if (promotionEligible && !giftLine) {
      // ✅ Eligible and gift not yet present → add gift + discount
      console.log("[FreeGift] Threshold met, no parts — adding gift.");
      const updatedCart = await addGiftToCart();
      if (updatedCart) {
        refreshCartUI(updatedCart);
        await applyDiscountCode(DISCOUNT_CODE);
        await refreshCartFromServer();
      }

    } else if (!promotionEligible && giftLine) {
      // ❌ No longer eligible (below threshold OR contains a part) → remove gift + discount
      const reason = hasPart ? "cart contains a part" : "below threshold";
      console.log(`[FreeGift] Removing gift and discount — ${reason}.`);
      const updatedCart = await removeGiftFromCart();
      if (updatedCart) {
        refreshCartUI(updatedCart);
        await removeDiscountCode();
        // Re-fetch and refresh after the discount session cookie is cleared,
        // so the cart UI reflects the correct totals straight away.
        await refreshCartFromServer();
      }
    }

  } catch (err) {
    console.error("[FreeGift] syncFreeGift error:", err);
  } finally {
    if (checkoutBtn) checkoutBtn.disabled = false;
    isUpdating = false;
  }
}


function refreshCartUI(cartData) {
  document.dispatchEvent(new CustomEvent("cart:update", {
    bubbles: true,
    detail: {
      resource: cartData,
      sourceId: "free-gift-script",
      data: { itemCount: cartData.item_count },
    },
  }));
  document.dispatchEvent(new CustomEvent("cart:refresh"));
}

async function refreshCartFromServer(delayMs = 600) {
  await new Promise(resolve => setTimeout(resolve, delayMs));
  try {
    const cart = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
    refreshCartUI(cart);
  } catch (err) {
    console.error("[FreeGift] refreshCartFromServer error:", err);
  }
}


function interceptCartFetch() {
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)/;
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const options    = args[1] || {};
    const isInternal = options.headers?.["X-Free-Gift-Internal"];
    const url        = typeof args[0] === "string" ? args[0] : (args[0]?.url ?? "");

    const response = await originalFetch.apply(this, args);

    if (CART_MUTATION_PATTERN.test(url) && !isInternal) {
      response.clone().json()
        .then(() => setTimeout(syncFreeGift, 400))
        .catch(() => {});
    }

    return response;
  };
}


async function handleCheckoutValidation(e) {
  try {
    const cart     = await fetch("/cart.js").then(r => r.json());
    const giftItem = findGiftLine(cart);

    if (giftItem && giftItem.quantity > 1) {
      e.preventDefault();
      e.stopImmediatePropagation();

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Free-Gift-Internal": "true",
        },
        body: JSON.stringify({ id: giftItem.key, quantity: 1 }),
      });

      window.location.reload();
    }
  } catch (err) {
    console.error("[FreeGift] handleCheckoutValidation error:", err);
  }
}


function init() {
  interceptCartFetch();
  syncFreeGift();

  const checkoutBtn = document.getElementById("checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", handleCheckoutValidation);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}